import React from "react";
import { motion } from "framer-motion";

// Lotus divider used across sections
export function LotusDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 my-8 ${className}`}>
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-[#C9A961]" />
      <svg width="28" height="20" viewBox="0 0 28 20" fill="none" className="text-gold">
        <path d="M14 18 C 8 14, 4 10, 6 4 C 9 5, 12 8, 14 12 C 16 8, 19 5, 22 4 C 24 10, 20 14, 14 18 Z" stroke="currentColor" strokeWidth="0.8" fill="none" opacity="0.85" />
        <path d="M14 16 C 11 13, 9 10, 10 6 C 12 7, 13 9, 14 11 C 15 9, 16 7, 18 6 C 19 10, 17 13, 14 16 Z" stroke="currentColor" strokeWidth="0.6" fill="none" opacity="0.6" />
      </svg>
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-[#C9A961]" />
    </div>
  );
}

// Reveal wrapper
export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

// Eyebrow label
export function Eyebrow({ children }) {
  return <div className="eyebrow">{children}</div>;
}

// Bead drop
export function BeadDrop() {
  return (
    <div className="flex flex-col items-center gap-1 text-gold opacity-80">
      <span className="w-1 h-1 rounded-full bg-current" />
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      <span className="w-1 h-1 rounded-full bg-current" />
    </div>
  );
}
